import { MessageCircle } from "lucide-react";
import { ChatMockup } from "./AddonChatMockup";

const highlights = [
  "Trained on your product catalog",
  "Shopee Live",
  "TikTok Chat",
];

export function AddonProductsSection() {
  return (
    <section id="addons" className="relative z-10 pt-16 md:pt-24 pb-16 md:pb-24 px-4 md:px-6 overflow-hidden">
      <div className="mx-auto max-w-[1200px]">
        <p className="text-[13px] uppercase tracking-[0.15em] text-muted-foreground mb-4">
          Add-on product
        </p>
        <h2 className="text-[clamp(1.5rem,3vw,2.5rem)] font-[500] tracking-[-0.03em] text-foreground max-w-[540px] leading-[1.15]">
          Extend your livestream<br />stack with AI Chat
        </h2>
        <p className="mt-4 text-[14px] md:text-[15px] text-muted-foreground max-w-[440px]">
          Product-trained replies on Shopee Live and TikTok Chat.
        </p>

        <div className="mt-10 md:mt-16 grid grid-cols-1 lg:grid-cols-2 border border-border">
          <div className="p-6 border-b lg:border-b-0 lg:border-r border-border flex items-center">
            <div className="border border-border bg-card/30 overflow-hidden rounded-lg w-full">
              <ChatMockup />
            </div>
          </div>

          <div className="p-6 flex flex-col justify-center">
            <div className="flex items-center gap-2 mb-3">
              <MessageCircle className="h-4 w-4 text-muted-foreground" />
              <span className="text-[11px] uppercase tracking-[0.12em] font-medium text-muted-foreground">
                AI Chat
              </span>
            </div>

            <h3 className="text-[15px] font-medium text-foreground mb-2 leading-snug">
              Reply while you are live
            </h3>
            <p className="text-[13px] leading-[1.6] text-muted-foreground mb-4">
              One AI answers customer questions on Shopee Live and TikTok Chat.
            </p>

            <div className="space-y-1.5 pt-3 border-t border-border">
              {highlights.map((h) => (
                <div key={h} className="flex items-center gap-2">
                  <div className="h-1 w-1 rounded-full bg-muted-foreground/40" />
                  <span className="text-[11px] text-muted-foreground">{h}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
